<!--
 * @Author: chaixueyuan chaixueyuan@huan.tv
 * @Date: 2023-10-31 15:36:59
 * @LastEditors: chaixueyuan chaixueyuan@huan.tv
 * @LastEditTime: 2023-10-31 15:39:58
 * @FilePath: /fwz/bdwph5/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png" /> -->
    <pageh></pageh>
    <!-- <fwz msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
import pageh from "./components/pageh.vue";

export default {
  name: "app",
  components: {
    pageh
  },
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  margin-left: 20px; */
}

html {
  /* -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%; */
  -ms-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  font-family: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei,
    Arial;
  margin: 0;
  background-color: #fff;
  height: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  margin: 0 auto;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue